<label class="c-switch" [ngClass]="{'c-switch--active': vm.isActive}">
	<span *ngIf="vm.label">{{ vm.label }}</span>
	<input type="checkbox" [(ngModel)]="vm.isActive" class="c-switch__input u-sr-only" (click)="vm.onClick()">
	<span class="c-switch__slider" aria-hidden="true"></span>
</label>
